import { createFileRoute, Link } from "@tanstack/react-router";
import { LegalPage } from "../components/legal-page";

export const Route = createFileRoute("/legal/complaints")({
  head: () => ({
    meta: [
      { title: "Complaints Procedure" },
      { name: "description", content: "How to raise a complaint with HR Service Centre, our response timescales, and escalation routes." },
      { property: "og:title", content: "Complaints Procedure" },
      { property: "og:url", content: "https://www.hrservicecentre.co.uk/legal/complaints" },
    ],
    links: [{ rel: "canonical", href: "https://www.hrservicecentre.co.uk/legal/complaints" }],
  }),
  component: ComplaintsPage,
});

function ComplaintsPage() {
  return (
    <LegalPage
      title="Complaints Procedure"
      intro="We take complaints seriously and aim to resolve concerns quickly and fairly."
      lastReviewed="2026-09-14"
    >
      <h2>How to raise a complaint</h2>
      <p>
        Use our <Link to="/contact-hr-experts">contact form</Link> and mark your message as a complaint, or write to
        us at HR Service Centre, 20-22 Wenlock Road, London, N1 7GU. Please include a description of the issue, your
        contact details and any relevant reference numbers or dates.
      </p>

      <h2>Our timescales</h2>
      <ul>
        <li>Acknowledgement within 3 working days.</li>
        <li>Substantive response within 15 working days.</li>
        <li>If the matter is complex we'll keep you informed of progress at least every 10 working days.</li>
      </ul>

      <h2>How we handle it</h2>
      <p>
        Your complaint is reviewed by someone not directly involved in the matter wherever possible. We will set out
        what we found, what we will put right and any changes we are making as a result.
      </p>

      <h2>Escalation</h2>
      <p>If you remain dissatisfied with our response, you can escalate as follows:</p>
      <ul>
        <li>For employment law matters handled by a solicitor: the Solicitors Regulation Authority (SRA) and Legal Ombudsman.</li>
        <li>For HR services: the CIPD professional conduct route.</li>
        <li>For data protection concerns: the Information Commissioner's Office at <a href="https://ico.org.uk">ico.org.uk</a>.</li>
      </ul>
    </LegalPage>
  );
}
